<div class="container">
    <div>
        <div class="header">
            @if(exceedsAmount){
            <div class="warning-div">
                <div class="warning-msg">
                    <span>Maximum balance exceeded!</span>
                </div>
            </div>
            } @else {
            <span class="header-title">Withdraw funds</span>
            }
            <div class="img-container" (click)="onClose()">
                <div class="cross-icon"></div>
            </div>
        </div>
        <div class="line"></div>
    </div>
    <div class="amount">
        <input type="text" placeholder="&#8377;0" [ngModel]="withDrawAmountDisplay"
            (ngModelChange)="onInputOfAmount($event)" (keydown)="preventLetters($event)">
        <span class="balance">Max. available - &#8377;{{data.amount.toLocaleString('en-IN')}}</span>
    </div>
    <div>
        <span class="limiter">{{optionalMsg.length}}/50</span>
        <textarea class="notes" [(ngModel)]="optionalMsg" placeholder="Add notes(optional)" maxlength="50"></textarea>
    </div>
    <div class="btn-div">
        @if(exceedsAmount || withDrawAmount===0){
        <button class="disable-btn" disabled="true">Can't Process</button>
        } @else {
        <button class="dp-primary-btn" (click)="onSubmit()">Request to withdraw {{withDrawAmountDisplay}}</button>
        }
        <button class="dp-secondary-btn" (click)="onClose()">Cancel</button>
    </div>
</div>